// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d85f6b9f","498":"0ac86935","703":"6d5d9d4b"}[chunkId] + ".chunk.js";
};